<template>
  <div>
    <v-dialog v-model="show" width="600px">
      <v-card>
        <v-card-title class="d-flex" style="position: relative"
                      :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
          <h3>{{isNew ? 'New Driver' : 'Edit Driver ' + user.id}}</h3>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-title class="justify-center">
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text :class="{'pb-0': $vuetify.breakpoint.smAndDown}">
          <v-container container--fluid grid-list-xl>
            <v-form
              ref="form"
              v-model="valid"
              :lazy-validation="lazy">
              <v-row justify="center" align="center">
                <v-col cols="10">
                  <v-text-field
                    v-model="user.name"
                    label="Name"
                    required
                    :rules="[(v) => !!v || 'Name is required']"
                    :append-icon="user.name ? 'mdi-check-circle' : 'mdi-alert-circle'"
                    :append-icon-cb="() => { user.name = '' }"
                  ></v-text-field>

                  <v-autocomplete
                    label="Choose a depot"
                    :items="regionDepots"
                    item-text="name"
                    item-value="id"
                    v-model="user.depot_id"
                    prepend-icon="fas fa-map-marked-alt"
                    required
                    :rules="[(v) => !!v || 'Depot is required']"
                    :append-icon="user.depot_id ? 'mdi-check-circle' : 'mdi-alert-circle'"
                    :append-icon-cb="() => { user.depot_id = null }"
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row justify="center" align="center" v-if="user.is_scanner">
                <v-col cols="12" md="10">
                  <v-select
                    :items="scanner_permissions"
                    v-model="user.scanner_level"
                    label="Scanner Permission"
                    required
                  ></v-select>
                </v-col>
              </v-row>

              <v-row justify="space-around" align="center">
                <v-col cols="12" md="3">
                  <v-switch
                    class="justify-center"
                    color="blue"
                    v-model="user.active"
                    :label="user.active ? 'Active' : 'Disabled'"
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="3">
                  <v-switch
                    class="justify-center"
                    color="blue"
                    v-model="user.is_driver"
                    label="Driver"
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="3">
                  <v-switch
                    class="justify-center"
                    color="blue"
                    v-model="user.is_scanner"
                    label="Scanner"
                  ></v-switch>
                </v-col>
              </v-row>

              <v-row justify="center" align="center">
                <v-col cols="6" style="text-align: center">
                  <v-btn
                    text
                    @click="$emit('close')"
                    color="blue-grey lighten-2"
                  >Cancel
                  </v-btn>
                </v-col>

                <v-col cols="6" style="text-align: center">
                  <v-btn
                    text
                    @click="save()"
                    color="blue darken-1"
                  >Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "EditContractorUser",
        props: {
            user: Object,
            editDialog: Boolean,
            regionDepots: Array
        },
        data() {
            return {
                valid: true,
                lazy: false,
                scanner_permissions: [
                    {text: 'None', value: 0},
                    {text: 'Scanner', value: 1},
                    {text: 'Lead Scanner', value: 2},
                    {text: 'Supervisor', value: 3},
                    {text: 'Manager', value: 4},
                ],
            }
        },

        computed: {
            show: {
                get() {
                    return this.editDialog;
                },
                set(value) {
                    if (!value) this.$emit('close');
                }
            },
            isNew() {
                return (this.user === null || this.user.id <= 0);
            }
        },

        methods: {
          save() {
            if (!this.$refs.form.validate()) {
              this.$store.commit('displaySnackbar', 'Please fill in all required fields');
              return;
            }

            this.$emit('save')
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Contractors/EditContractorUser.vue